<script>
  import viewport from '@/js/utils/useViewportAction.js';

  export let items = [];
  let grow = false;
</script>

<section
  class="typo"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="container">
    <div class="flexbox flexbox--grid">
      {#each items as item}
        <div class="col col-50 col-m-full">
          <h2 class="h5 typo-item__title">{item.title}</h2>
          <p class="text-small typo-item__desc">{item.desc}</p>
        </div>
      {/each}
    </div>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .typo {
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    .flexbox--grid {
      @include resp-max('s') {
        row-gap: 3rem;
      }
    }
  }
  .typo-item {
    &__title {
      @include resp-max('s') {
        font-size: 2.4rem;
      }
    }
    &__desc {
      margin: 1.5rem 0 0;
      color: var(--royal-light);
    }
  }
</style>
